import {Currency, useGetAppSettingsQuery, useGetCompanyInfoQuery} from "../generated/graphql";

/**
 * Tarif 595 (Rückforderungsbelege für Schweizer Zusatzversicherungen) ist nur mit Superuser-Flag
 * featureTarif595 und Währung CHF aktiv. Beide Abfragen liegen nach dem App-Start im Apollo-Cache.
 */
export const useTarif595Enabled = (): boolean => {
    const {data: companyInfo} = useGetCompanyInfoQuery();
    const {data: appSettings} = useGetAppSettingsQuery();

    return companyInfo?.companyInfo?.subscription?.featureTarif595 === true && appSettings?.settings?.currency === Currency.Chf;
};
